import React from "react";

import { PeriscopeTileIcon, TileOpacities } from "./periscope-tile-icon";

// Flat white mark on the brand-purple tile (exploration "variant C").
const LOGO_OPACITIES: TileOpacities = {
  brand: 1,
  deep: 1,
  pale: 1,
  dot: 1,
};

interface PeriscopeLogoProps {
  /** Tile size in px (square). */
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

/**
 * The Periscope app logo: the mark in white on a rounded brand-purple tile.
 * Purpose-built for the sidenav header; the tile colour is intentionally the
 * same in light and dark mode to keep the brand identity constant.
 */
export function PeriscopeLogo({
  size = 20,
  style,
  className,
}: PeriscopeLogoProps) {
  return (
    <PeriscopeTileIcon
      size={size}
      opacities={LOGO_OPACITIES}
      style={style}
      className={className}
    />
  );
}
